<template>
	<div>
		<div class="card" :style="{'background-color':item.state<5?'#ffffff':'#f2f2f2','box-shadow':mouseover?'0px 0px 10px 2px #4A90E2':''}"
		 @click="projectDetail" @mouseover="mouseover=true" @mouseout="mouseover=false">
			<div class="card-top">
				<label class="title-ellipsis">{{getitemTitle(item.title)}}</label>
				<label class="card-top-state">{{COLLECT_STATE_MAP[item.state]}}</label>
			</div>
			<div class="card-item" style="margin-top:14px">
				<label class="card-item-title">{{'ID:'}}</label>
				<label class="card-item-value">{{getitemTitle(item.job_uid)}}</label>
			</div>
			<div class="card-item">
				<label class="card-item-title">{{'数据处理流程'}}</label>
			</div>
			<div class="card-item">
				<template v-for="(option,index) in item.options" v-if="index !== item.options.length - 1">
					<el-button type="primary" plain size="mini">{{option.option.title}}</el-button>
					<i class="el-icon-arrow-right" style="color:#0081EC"></i>
				</template>
				<el-button type="primary" plain size="mini" v-if="item.options.length">{{item.options[item.options.length - 1].option.title}}</el-button>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.card {
        position: relative;
		cursor: pointer;
		background-color: #ffffff;
		border: 1px solid #c0ccda;
		text-align: left;
		float: left;
		width: 334px;
		height: 211px;
		margin-top: 0px;
		overflow: hidden;

		.card-top {
			margin-top: 31px;
			margin-left: 19px;
			margin-right: 19px;

			.card-top-state {
				font-size: 14px;
				margin-left: auto;
				margin-right: 0px;
				float: right;
				color: #000000;
			}

			.title-ellipsis {
				margin-left: 0px;
				font-size: 8px;
				font-size: 16px;
				color: #030303;
			}
		}

		.card-item {
			margin-left: 19px;
			margin-right: 10px;
			margin-top: 8px;
			height: 20px;

			.card-item-title {
				font-size: 14px;
				color: #030303;
			}

			.card-item-value {
				font-size: 14px;
				color: #3b3a3a;
			}

			.el-button.is-plain {
				padding-top: 3px;
				padding-bottom: 3px;
			}
		}

		.card-bottom {
			height: 44px;
			background-color: #f7faff;
			text-align: center;
			display: flex;
			border-top: #c0ccda solid 1px;
            position:absolute;
            bottom:0 ;
			.card-bottom-button {
				color: #1890ff;
				font-size: 14px;
				width: 100%;
				height: 44px;
			}

			.card-bottom-vline {
				height: 25px;
				width: 1px;
				background-color: #c0ccda;
				margin-top: 10px;
			}
		}
	}

</style>
<script>
	import ProjectOperationFlowUtils from "@/js/utils/projectOperationFlow";
	import config from "@/js/utils/config";
	import {
		MessageBox
	} from "element-ui";
	export default {
		name: "PMSProjectCard",
		props: {
			source: String,
			item: {}
		},

		data() {
			return {
				confirmConfigDialogShow: false,
				bottomMouseover: [{
						mouseover: false,
					},
					{
						mouseover: false,
					}
				], //此处最多两个按钮，须优化成动态展示为操作按钮个数相同

				bottomMouseoverLineShow: [{
						lineShow: true,
					},
					{
						lineShow: true,
					}
				],
				mouseover: false,
				COLLECT_STATE: ProjectOperationFlowUtils.COLLECT_STATE,
				COLLECT_STATE_MAP: ProjectOperationFlowUtils.COLLECT_STATE_MAP,
				PROJECT_LIST_CARD_OPERATION: ProjectOperationFlowUtils.PROJECT_LIST_CARD_OPERATION,
				workflows: [],
				workflow: '',
				operationButtons: []
			};
		},
		created() {
			this.operationButtons = this.getOperationButtons();
		},

		watch: {

			bottomMouseover: {
				handler: function (newVal, oldVal) {
					for (let index = 0; index < this.bottomMouseover.length; index++) {
						const element = this.bottomMouseover[index];
						const lineShowElement = this.bottomMouseoverLineShow[index];
						if (element.mouseover) {
							//一次取相邻的两个变量（此处为后一个变量）将相邻的后面的竖线隐藏
							if (index > 0) {
								const nextElement = this.bottomMouseoverLineShow[index - 1];
								nextElement.lineShow = false;
							}
							if (this.operationButtons.length == 2) {
								lineShowElement.lineShow = false;
							} else {
								lineShowElement.lineShow = true;
							}
						} else {
							lineShowElement.lineShow = true;
						}

					}
				},
				deep: true
			},
		},
		methods: {
             initDataValue(){
                this.bottomMouseoverLineShow= [{
						lineShow: true,
					},
					{
						lineShow: true,
					}
				];
				
				this.bottomMouseover= [{
					mouseover: false
				}, {
					mouseover: false
				}];//此处最多两个按钮，须优化成动态展示为操作按钮个数相同
				this.mouseover=false;
            },

			getCollectTotalCount() {
				if (!this.item.total_count || parseInt(this.item.total_count) == 0) {
					return "暂无记录";
				}
				return this.item.total_count;
			},
			getitemTitle(title) {
				if (title.length > 20) {
					let newtitle = title.slice(0, 20) + "...";
					return newtitle;
				}
				return title;
			},
			projectDetail() {

				this.$emit("projectDetail", this.item.id, this.item.edit, this.item.job_uid);
			},
			buttonTitle(item) {
				return this.PROJECT_LIST_CARD_OPERATION[item];
			},

			getOperationButtons() {
				let operations = this.projectListCardOperation(this.item.procedure_state);
				return operations;
			},
			projectOperation(operation) {
                this.initDataValue();
				this.operation(operation, this.item.id, this.item.state);
			},

			operation(operation, projectID, projectState) {
				let userinfo = JSON.parse(localStorage.getItem("userinfo"));
				console.log("operation:" + operation);

				switch (operation) {
                    case "CONFIG":
                    	this.confirmConfigDialogShow = true;
						break;
					case "MODIFY":
						this.confirmConfigDialogShow = true;
						break;
					case "MANUAL":

						break;
					default:
						break;
				}
			},

			projectListCardOperation(projectStatus) {
				var buttons = [];
				switch (projectStatus) {
                     case 0:// 未配置
                        buttons = ["CONFIG"];
						break;
					case 1:// 配置
						buttons = ["MODIFY", "MANUAL"];
						break;
					default:
						break;
				}
				return buttons;
			},
			configProjectAction() {
				this.updataProject(this.item.id, this.COLLECT_STATE.FINISH);
			}
		}
	};

</script>



// WEBPACK FOOTER //
// src/js/modules/project/ui/etl_project/project_history_list/PMSProjectCard.vue